import React, { useState } from 'react'
import Form from './form'

export default function CourseAdd (props) {
  const [data, setData] = useState({})

  return <Form mode='add' data={data} setData={setData} {...props} />
}